import { ROLE } from "../constants/role";

export const isAdmin = (userData: any) => {
  return userData?.permissionGroups?.includes(ROLE.PUBLISHER) || userData?.permissionGroups?.includes(ROLE.EDITOR);
};
